"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DenseMatrixDependencies = void 0;

var _dependenciesMatrixClassGenerated = require("./dependenciesMatrixClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var DenseMatrixDependencies = {
  MatrixDependencies: _dependenciesMatrixClassGenerated.MatrixDependencies,
  createDenseMatrixClass: _factoriesAny.createDenseMatrixClass
};
exports.DenseMatrixDependencies = DenseMatrixDependencies;